import { useContext } from 'react';

import { ChannelsContext } from '../contexts';

export function useChannelsContext() {
  return useContext(ChannelsContext);
}
